module.exports = __webpack_public_path__ + "img/wonderroman_tech_Normal_ua.cd5aba3c.webp";